// src/data/planning/activityTypeCatalog.js

/**
 * REHBER360 - RESMÎ FAALİYET TÜRÜ KATALOĞU
 *
 * Hedef çalışmalarında kullanılabilecek faaliyet türleri,
 * MEB Hedef Çalışmaları İş Akış Çizelgesindeki
 * Düzey 1 / 2 / 3 faaliyet gruplarından alınmıştır.
 *
 * Serbest metinle faaliyet türü oluşturulmaz.
 */


export const ACTIVITY_TYPE_CATALOG_VERSION =
  "MEB-HEDEF-FAALIYET-TURLERI-2023-V1";


// =========================================================
// DÜZEY 1
// Büyük grup ve sınıf rehberliği çalışmaları
// =========================================================

export const LEVEL_1_ACTIVITY_TYPES = [

  {
    id: "publication_preparation",
    officialLabel:
      "Yayın Hazırlama (Broşür, Bülten, Okul/Kurum Web Sitesi İçeriği, Pano/Etkileşimli Pano, Afiş, Poster vb.)",
    shortLabel:
      "Yayın Hazırlama",
    level: 1,
    active: true
  },

  {
    id: "conference_panel",
    officialLabel:
      "Konferans/Panel Düzenleme",
    shortLabel:
      "Konferans/Panel",
    level: 1,
    active: true
  },

  {
    id: "seminar",
    officialLabel:
      "Seminer Düzenleme",
    shortLabel:
      "Seminer",
    level: 1,
    active: true
  },

  {
    id: "trip",
    officialLabel:
      "Gezi Düzenleme",
    shortLabel:
      "Gezi",
    level: 1,
    active: true
  },

  {
    id: "class_guidance_single_activity",
    officialLabel:
      "Sınıf Rehberliği Tek Etkinlik Uygulama",
    shortLabel:
      "Sınıf Rehberliği Tek Etkinlik",
    level: 1,
    active: true
  },

  {
    id: "class_guidance_program_single_activity",
    officialLabel:
      "Sınıf Rehberlik Programı Tek Etkinlik Uygulama",
    shortLabel:
      "Sınıf Rehberlik Programı Tek Etkinlik",
    level: 1,
    active: true
  },

  {
    id: "media_book_evaluation",
    officialLabel:
      "Masal/Hikaye/Film/Animasyon/Video/Kitap Değerlendirme",
    shortLabel:
      "İçerik Değerlendirme",
    level: 1,
    active: true
  },

  {
    id: "alumni_meeting",
    officialLabel:
      "Mezunla Buluşma Etkinliği Düzenleme",
    shortLabel:
      "Mezunla Buluşma",
    level: 1,
    active: true
  }

];


// =========================================================
// DÜZEY 2
// Ardışık büyük grup / sınıf rehberliği ve küçük grup
// =========================================================

export const LEVEL_2_ACTIVITY_TYPES = [

  {
    id: "conference_panel_series",
    officialLabel:
      "Konferans/Panel Serisi Düzenleme",
    shortLabel:
      "Konferans/Panel Serisi",
    level: 2,
    active: true
  },

  {
    id: "seminar_series",
    officialLabel:
      "Seminer Serisi Düzenleme",
    shortLabel:
      "Seminer Serisi",
    level: 2,
    active: true
  },

  {
    id: "trip_series",
    officialLabel:
      "Gezi Serisi Düzenleme",
    shortLabel:
      "Gezi Serisi",
    level: 2,
    active: true
  },

  {
    id: "psychoeducation_application",
    officialLabel:
      "Psikoeğitim Programı Uygulama",
    shortLabel:
      "Psikoeğitim Programı Uygulama",
    level: 2,
    active: true
  },

  {
    id: "social_responsibility_project",
    officialLabel:
      "Sosyal Sorumluluk Çalışmaları/Projeleri Yürütme",
    shortLabel:
      "Sosyal Sorumluluk Çalışması",
    level: 2,
    active: true
  },

  {
    id: "class_guidance_sequential_activity",
    officialLabel:
      "Sınıf Rehberlik Programı Aynı Kazanıma Ait Ardışık Etkinlik Uygulama",
    shortLabel:
      "Ardışık Sınıf Rehberlik Etkinliği",
    level: 2,
    active: true
  },

  {
    id: "alumni_meeting_series",
    officialLabel:
      "Mezunla Buluşma Etkinlik Serisi Düzenleme",
    shortLabel:
      "Mezunla Buluşma Serisi",
    level: 2,
    active: true
  },

  {
    id: "action_plan",
    officialLabel:
      "Eylem Planı Hazırlama ve Uygulama",
    shortLabel:
      "Eylem Planı",
    level: 2,
    active: true
  }

];


// =========================================================
// DÜZEY 3
// Küçük grup / yoğunlaştırılmış müdahale
// =========================================================

export const LEVEL_3_ACTIVITY_TYPES = [

  {
    id: "group_counseling",
    officialLabel:
      "Grupla Psikolojik Danışma",
    shortLabel:
      "Grupla Psikolojik Danışma",
    level: 3,
    active: true
  },

  {
    id: "focus_group",
    officialLabel:
      "Odak Grup Çalışması",
    shortLabel:
      "Odak Grup Çalışması",
    level: 3,
    active: true
  },

  {
    id: "psychoeducation_prepare_and_apply",
    officialLabel:
      "Psikoeğitim Programı Hazırlama ve Uygulama",
    shortLabel:
      "Psikoeğitim Programı Hazırlama ve Uygulama",
    level: 3,
    active: true
  }

];


// =========================================================
// HEDEF DIŞI / SİSTEMDE AYRI FAALİYET TÜRÜ OLARAK
// KULLANILAN DEĞERLER
//
// Bunlar hedef Düzey 1-2-3 listesine dahil değildir.
// Ek grup çalışmalarında kullanılacaktır.
// =========================================================

export const SYSTEM_ACTIVITY_TYPES = [

  {
    id: "meeting",
    officialLabel:
      "Toplantı",
    shortLabel:
      "Toplantı",
    level: null,
    active: true,
    targetEligible: false
  },

  {
    id: "individual_recognition_techniques",
    officialLabel:
      "Bireyi Tanıma Teknikleri",
    shortLabel:
      "Bireyi Tanıma Teknikleri",
    level: null,
    active: true,
    targetEligible: false
  }

];


// =========================================================
// TÜM KATALOG
// =========================================================

export const ACTIVITY_TYPE_CATALOG = [

  ...LEVEL_1_ACTIVITY_TYPES,
  ...LEVEL_2_ACTIVITY_TYPES,
  ...LEVEL_3_ACTIVITY_TYPES,
  ...SYSTEM_ACTIVITY_TYPES

];


// =========================================================
// HELPERS
// =========================================================

export const getActivityTypeById = (
  activityTypeId
) => {

  return (
    ACTIVITY_TYPE_CATALOG.find(
      type =>
        type.id === activityTypeId &&
        type.active
    ) ||
    null
  );
};


export const getActivityTypesByLevel = (
  level
) => {

  return ACTIVITY_TYPE_CATALOG.filter(
    type =>
      type.active &&
      type.level === level
  );
};


export const getTargetActivityTypeOptions = ({
  level = 1
} = {}) => {

  return getActivityTypesByLevel(
    level
  );
};


// =========================================================
// EK GRUP ÇALIŞMALARI İÇİN DOĞRULANMIŞ FAALİYET TÜRÜ
//
// Yalnızca kaynağı açık olan kategoriler otomatik atanır.
// Doğrulanmamış kategoriler için faaliyet türü tahmin edilmez
// ve kullanıcıya serbest tür seçimi yaptırılmaz.
// =========================================================
export const getDefaultActivityTypeForAdditionalCategory = (
  category
) => {

  const defaults = {

    individual_recognition:
      "individual_recognition_techniques",

    cooperation_meetings:
      "meeting",

    group_counseling:
      "group_counseling"

  };


  const activityTypeId =
    defaults[
      category
    ];


  if (!activityTypeId) {
    return null;
  }


  return getActivityTypeById(
    activityTypeId
  );
};